module.exports = __webpack_public_path__ + "static/img/30008 (3).38b0d36.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30008 (3).webp
// module id = Po6w
// module chunks = 14